const BODY_CONTENT_HORIZONTAL_PADDING = 96;

const COMPONENTS_SHADOW_PROPS = {
  offsetX: 0,
  offsetY: 8,
  blurRadius: 48
};

const getComponentShadowFilter = (opacity) => {
  return `drop-shadow(0px ${COMPONENTS_SHADOW_PROPS.offsetY}px ${COMPONENTS_SHADOW_PROPS.blurRadius / 2}px rgba(29, 140, 242, ${opacity}))`
};

const COMPONENTS_SHADOW_FILTER = getComponentShadowFilter(0.5);

module.exports = {
  BODY_CONTENT_HORIZONTAL_PADDING,
  COMPONENTS_SHADOW_PROPS,
  COMPONENTS_SHADOW_FILTER,
  getComponentShadowFilter
};
